// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EntityType = {
  Process: "process",
  ProjectFile: "project_file",
  ProjectDirectory: "project_directory",
  User: "user",
  Project: "project",
  Invitation: "invitation",
  Dataset: "dataset",
  Job: "job",
  Publication: "publication",
  PublicationComment: "publication_comment",
  ApiKey: "api_key",
} as const;
export type EntityType = (typeof EntityType)[keyof typeof EntityType];

export function instanceOfEntityType(value: any): boolean {
  for (const key in EntityType) {
    if (Object.prototype.hasOwnProperty.call(EntityType, key)) {
      if (EntityType[key as keyof typeof EntityType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function EntityTypeFromJSON(json: any): EntityType {
  return EntityTypeFromJSONTyped(json, false);
}

export function EntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityType {
  return json as EntityType;
}

export function EntityTypeToJSON(value?: EntityType | null): any {
  return value as any;
}

export function EntityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): EntityType {
  return value as EntityType;
}
